export default __webpack_public_path__ + "static/media/crutch.6745d59c.svg";